 export enum MxExportMode {
    AllWithEveryColumn = 0,
    AllWithSelectedColumn = 1,
    FilteredWithEveryColumn = 2,
    FilteredWithSelectedColumn = 3,
  }
